module.exports = __webpack_public_path__ + "img/smartphoneBanner.f2ea773.webp";